<template>
  <div class="login">

    <div class="title">
      <div class="logo">
        <img src="@/assets/login/logo.png" class="img" />
      </div>
      <div class="title_text">
        欢迎使用 猎寻服务中心
      </div>
    </div>
    <van-form @submit="onSubmit" ref="vanForm">
      <div class="name-field box">
        <div>
          +86
        </div>
        <van-field v-model="phone" placeholder="请输入您的电话号码" :rules="rules.phone" />
      </div>
      <div>密码</div>
      <van-field class="name-field" type="password" v-model="password" placeholder="请输入您的密码" :rules="rules.password" />
      <div>
        <van-button block type="info" :loading="loading" class="login_btn" native-type="submit">登录</van-button>
        <div class="login_text" @click="register">注册账号
        </div>
      </div>
    </van-form>
  </div>
</template>

<script>
import { loginUser, sendLoginSuccess } from '@/api/index'
export default {
  data() {
    return {
      phone: '',
      password: '',
      loading: false,
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'onBlur' },
          { validator: this.validatorPhone, message: '请输入正确的手机号码', trigger: 'onBlur' },
        ],
        password: [
          { required: true, message: '请输入您的密码' },
        ],
      },
    }
  },
  methods: {
    validatorPhone(val) {
      // 手机号码验证
      return /^1[3-9]\d{9}$/.test(val);
    },
    onSubmit() {
      // 校验表单
      this.$refs.vanForm.validate().then(() => {
        this.loading = true;
        let data = {
          username: this.phone,
          password: this.password,
          openId: localStorage.getItem('id')
        }
        loginUser(data).then(res => {
          console.log(res);
          localStorage.setItem('token', res.token);
          this.loading = false
          this.send()
          this.closePage()
        }).catch(err => {
          console.log(err);
          this.loading = false
        })
      }).catch((error) => { });
    },
    send() {
      let data = {
        openId: localStorage.getItem('id')
      }
      sendLoginSuccess(data).then(res => {
        console.log(res);
      }).catch(err => {
        console.log(err);
      })
    },
    register() {
      this.$router.push('/signup');
    },
    //关闭页面
    closePage() {
      if ((navigator.userAgent.indexOf('Firefox') != -1 || navigator.userAgent.indexOf('Chrome') != -1) && !this
        .isWechat()) {
        console.log('Firefox或者Chrome浏览器');
        window.location.href = 'about:blank'
        window.close()
      } else if (this.isWechat()) {
        console.log('微信内置浏览器');
        this.closePageWx()
      } else {
        console.log('其他浏览器');
        window.opener = null
        window.open('', '_self')
        window.close()
      }
    },
    // 判断环境
    isWechat() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/micromessenger/i) == 'micromessenger') { // 判断是否在微信浏览器内
        return true;
      } else {
        return false;
      }
    },
    // 微信内置浏览器关闭
    closePageWx() {
      // isWechat是我写的一个判断当前环境是否是微信内置浏览器 的方法
      if (!this.isWechat()) return // 非微信环境下，不做处理 
      setTimeout(function () {
        if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
          WeixinJSBridge.invoke('closeWindow', {}, function (res) {
            if (res.err_msg == "close_window:ok") {
              // 关闭成功的处理
              console.log('关闭成功的处理')
            } else {
              // 关闭失败的处理
              console.log('关闭失败的处理')
            }
          });
        }
      }, 100);
    },
  }
}
</script>

<style lang="less" scoped>
.login {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;

  .title {
    margin-top: 40px;
    text-align: center;

    .logo {
      display: inline-block;
      background-color: rgba(255, 255, 255, 1);
      text-align: center;
      font-family: Roboto;
      border: 4px solid rgba(43, 70, 138, 1);
      padding: 10px;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      position: relative;

      .img {
        width: 63px;
        height: 55.83px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .title_text {
      margin: 20px 0;
      font-weight: bold;
      color: rgb(16, 16, 16);
      font-size: 0.22rem;
      text-align: left;
      font-family: PingFangSC-bold;
    }
  }

  .name-field {
    border-bottom: 1px solid #ccc;
  }

  .box {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .login_btn {
    margin-top: 20px;
    border-radius: 8px;
    background-color: rgba(43, 70, 138, 1);
    color: #fff;
    font-size: 0.14rem;
    text-align: center;
    font-family: Roboto;
  }

  .login_text {
    margin-top: 10px;
    font-size: 0.14rem;
    color: rgba(43, 70, 138, 1);
    text-align: right;
  }
}
</style>